// src/filter/registry.ts
import type { FilterKey, Option } from "@/filter";
import { statusOptions } from "@/hooks/useSelect";
import { FarmerGroupResponse } from "../parts/master/farmer-group/interface";

export type SourceKind =
  | { type: "static"; data: Option[] }
  | { type: "endpoint"; url: string; map?: (raw: any) => Option[] }
  | {
      type: "loader";
      load: (ctx?: { signal?: AbortSignal; q?: string }) => Promise<Option[]>;
    };

export type FilterRegistry = Record<FilterKey, SourceKind>;

export const defaultFilterRegistry: FilterRegistry = {
  poktan: {
    type: "endpoint",
    url: "master/poktan?limit=9999",
    map: (data: DataPaginate<FarmerGroupResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  instansi: {
    type: "endpoint",
    url: "master/instansi?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  status: {
    type: "static",
    data: statusOptions,
  },
  kategoriPengajuan: {
    type: "static",
    data: [
      { label: "Semua", value: "" },
      { label: "Hibah", value: "Hibah" },
      { label: "Pinjam Pakai", value: "PinjamPakai" },
    ],
  },
  kategoriBrigade: {
    type: "endpoint",
    url: "master/alsintan-category?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  alsinstan: {
    type: "endpoint",
    url: "master/alsintan?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  roles: {
    type: "endpoint",
    url: "master/role?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  users: {
    type: "endpoint",
    url: "master/user?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
};
